module.exports = __webpack_public_path__ + "static/media/createCommentHover.1408ac6d.png";